/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_Col_LotsInputs */

const vi_chot_so_col_lots = /** @type {(inputs: Chot_So_Col_LotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lô`)
};

/**

* @param {Chot_So_Col_LotsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_col_lots = /** @type {((inputs?: Chot_So_Col_LotsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_Col_LotsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_col_lots(inputs)
});